// extracted by mini-css-extract-plugin
module.exports = {"captcha__wrapper":"Captcha_captcha__wrapper__a5nEe","captcha":"Captcha_captcha__jKaOw","captcha__error":"Captcha_captcha__error__X4hIR"};